import { registerPlugin } from '@capacitor/core';

import type { TiktokSharePlugin } from './definitions';

const TiktokShare = registerPlugin<TiktokSharePlugin>('TiktokShare', {
    web: () => import('./web').then((m) => new m.TiktokShareWeb()),
});

export * from './definitions';
export { TiktokShare };
